// src/components/home/SolutionAreas.js
// Homepage grid of the six core solution areas, each linking to its page.
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../SectionTitle';
import { SOLUTIONS, HOME_SOLUTION_KEYS } from '../../data/solutions';

const SolutionAreas = () => {
    const { t } = useTranslation();
    const areas = HOME_SOLUTION_KEYS.map((key) => SOLUTIONS.find((s) => s.key === key));

    return (
        <div id="solutions" className="bg-gray-100 py-12">
            <section data-aos="fade-up">
                <SectionTitle title={t('home.areas.title')} subtitle={t('home.areas.subtitle')} />

                <div className="px-4 sm:px-8" data-aos="fade-up" data-aos-delay="200">
                    <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
                        {areas.map((s) => (
                            <Link
                                key={s.slug}
                                to={`/solutions/${s.slug}`}
                                className="bg-white group rounded-lg shadow-xl p-6 flex flex-col transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 border-t-4 border-transparent hover:border-primary"
                            >
                                <div className="text-primary mb-4">{s.icon}</div>
                                <h3 className="font-bold text-xl text-gray-800 group-hover:text-primary mb-3 transition-colors">
                                    {t(`home.areas.${s.key}.title`)}
                                </h3>
                                <p className="text-gray-600 flex-grow text-justify">
                                    {t(`home.areas.${s.key}.desc`)}
                                </p>
                                <span className="mt-4 text-primary font-semibold inline-flex items-center">
                                    {t('common.learn_more')}
                                    <svg className="w-4 h-4 ml-1 transition-transform duration-300 group-hover:translate-x-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                </span>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default SolutionAreas;
